export const response15 = {
	"Payload": {
		"Match": {
			"ResponseNumber": 15,
			"Id": "tutorial",
			"Version": 1,
			"CreatorId": 22,
			"Type": "ch",
			"State": "pr",
			"BlockingType": "alternate",
			"PlayerCount": 2,
			"ActiveRoundNum": 3,
			"ActiveUserId": 22,
			"RoundCount": 3,
			"CreatedTime": 1582666798,
			"UpdatedTime": 1582666798,
			"InvitedTime": 0,
			"CompletedTime": 0,
			"CanAcceptChallenge": false,
			"IsStartHand": true,
			"CanRollDice": true,
			"CanApplyFreeroll": false,
			"CanApplyHandReset": false,
			"CanKeepHand": false,
			"CanResignMatch": true,
			"UserAcceptedTime": 1582666798,
			"UserResignedTime": 0,
			"UserCurrentRound": 3,
			"UserActiveTime": 1582666798,
			"UserNudgedTime": 0,
			"UserNudgeSentTime": 0,
			"UserFreeRolls": 0,
			"UserFreeRollsUsed": 0,
			"UserState": "pl",
			"UserBaseScore": 0,
			"UserFinalScore": 0,
			"UserOutcome": 0,
			"Opponents": [{
				"UserId": 92,
				"Username": "Ava",
				"DisplayName": "Ava",
				"ImageUrl": "/assets/tutorial/bots_ava_2.png",
				"AcceptedTime": 0,
				"ResignedTime": 0,
				"CurrentRound": 0,
				"ActiveTime": 0,
				"NudgedTime": 0,
				"NudgeSentTime": 0,
				"State": "pr",
				"TotalScore": 0,
				"Outcome": 0,
				"IsBot": true,
				"MatchRounds": []
			}],
			"Rounds": [{
				"RoundNum": 1,
				"Rolls": 3,
				"State": "pl",
				"TargetHand": 3,
				"TargetHandPoints": 1000,
				"TargetHandBonusPoints": 1000,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": false
			}, {
				"RoundNum": 2,
				"Rolls": 3,
				"State": "ns",
				"TargetHand": 4,
				"TargetHandPoints": 1000,
				"TargetHandBonusPoints": 1000,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": false
			}, {
				"RoundNum": 3,
				"Rolls": 3,
				"State": "ns",
				"TargetHand": 5,
				"TargetHandPoints": 2500,
				"TargetHandBonusPoints": 2500,
				"WinnerTakeAll": false,
				"SectionBonus": 0,
				"SectionEnd": true
			}],
			"UserMatchRounds": [{
				"RoundNum": 1,
				"RetryLimit": 1,
				"RetryNum": 0,
				"State": "co",
				"Score": 1000,
				"FinalScore": 0,
				"Outcome": 0,
				"FreeRollLimit": 1,
				"FreeRollsUsed": 0,
				"FinalDiceRoll": [5, 1, 0, 0, 3, 5, 2, 5, 5],
				"FinalDiceFaces": ["9c", "4s", "5h", "Qh", "6s", "Qc", "9h", "4h", "2h"],
				"BestHand": [3, 5, 6, 0],
				"BestHandFaces": ["Qh", "Qc", "9h", "9c"],
				"BestHandTarget": 3,
				"BestPossibleHand": false,
				"SectionBonus": 0,
				"Rolls": [{
					"RollNum": 1,
					"DiceRoll": [2, 1, 0, 1, 1, 0, 1, 1, 1],
					"DiceFaces": ["Jd", "4s", "5h", "10c", "3c", "2c", "7c", "6d", "Jc"],
					"Selection": [],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [],
					"BestHandFaces": [],
					"BestHandTarget": 3,
					"BestPossibleHand": false
				}, {
					"RollNum": 2,
					"DiceRoll": [2, 3, 0, 1, 1, 0, 1, 1, 1],
					"DiceFaces": ["Jd", "Xj", "5h", "10c", "3c", "2c", "7c", "6d", "Jc"],
					"Selection": [0, 8],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [0,1,3,8],
					"BestHandFaces": ["Jd", "Xj", "10c", "Jc"],
					"BestHandTarget": 3,
					"BestPossibleHand": false
				}, {
					"RollNum": 3,
					"DiceRoll": [2, 3, 0, 1, 1, 0, 1, 3, 1],
					"DiceFaces": ["Jd", "Xj", "5h", "10c", "3c", "2c", "7c", "Ad", "Jc"],
					"Selection": [0, 1, 8],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [1,7,0,8],
					"BestHandFaces": ["Xj", "Ad", "Jd", "Jc"],
					"BestHandTarget": 3,
					"BestPossibleHand": false
				}]
			}, {
				"RoundNum": 2,
				"RetryLimit": 1,
				"RetryNum": 0,
				"State": "rc",
				"Score": 1000,
				"FinalScore": 2000,
				"Outcome": 0,
				"FreeRollLimit": 1,
				"FreeRollsUsed": 0,
				"FinalDiceRoll": [5, 0, 5, 2, 0, 2, 0, 3, 0],
				"FinalDiceFaces": ["9c", "Ah", "Ks", "Kd", "As", "8s", "Qs", "Ad", "Kh"],
				"BestHand": [1, 4, 7],
				"BestHandFaces": ["Ah", "As", "Ad"],
				"BestHandTarget": 4,
				"BestPossibleHand": true,
				"SectionBonus": 0,
				"Rolls": [{
					"RollNum": 1,
					"DiceRoll": [0, 1, 1, 5, 5, 0, 4, 1, 0],
					"DiceFaces": ["7s", "4s", "Qd", "2s", "Jh", "2c", "Td", "6d", "Kh"],
					"Selection": [],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [],
					"BestHandFaces": [],
					"BestHandTarget": 4,
					"BestPossibleHand": false
				}, {
					"RollNum": 2,
					"DiceRoll": [1, 0, 5, 5, 0, 0, 0, 1, 3],
					"DiceFaces": ["3h", "Ah", "Ks", "2s", "As", "2c", "Qs", "6d", "Ts"],
					"Selection": [3,5],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [],
					"BestHandFaces": [],
					"BestHandTarget": 4,
					"BestPossibleHand": false
				}, {
					"RollNum": 3,
					"DiceRoll": [5, 0, 5, 2, 0, 2, 0, 3, 0],
					"DiceFaces": ["9c", "Ah", "Ks", "Kd", "As", "8s", "Qs", "Ad", "Kh"],
					"Selection": [1,4],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [1, 4, 7],
					"BestHandFaces": ["Ah", "As", "Ad"],
					"BestHandTarget": 4,
					"BestPossibleHand": true
				}]
			}, {
				"RoundNum": 3,
				"RetryLimit": 1,
				"RetryNum": 0,
				"State": "pl",
				"Score": 0,
				"FinalScore": 0,
				"Outcome": 0,
				"FreeRollLimit": 1,
				"FreeRollsUsed": 0,
				"DiceRoll": [5, 1, 1, 2, 3, 0, 4, 0, 2],
				"DiceFaces": ["9c", "4s", "Qd", "Kd", "6s", "2c", "Td", "Js", "8h"],
				"BestHand": [3, 2, 7, 6, 0],
				"BestHandFaces": [
					"Kd",
					"Qd",
					"Js",
					"Td",
					"9c"
				],
				"BestHandTarget": 5,
				"BestPossibleHand": false,
				"SectionBonus": 0,
				"Rolls": [{
					"RollNum": 1,
					"DiceRoll": [5, 1, 1, 2, 3, 0, 4, 0, 2],
					"DiceFaces": ["9c", "4s", "Qd", "Kd", "6s", "2c", "Td", "Js", "8h"],
					"Selection": [],
					"FreeRoll": false,
					"Completed": false,
					"BestHand": [3, 2, 7, 6, 0],
					"BestHandFaces": [
						"Kd",
						"Qd",
						"Js",
						"Td",
						"9c"
					],
					"BestHandTarget": 5,
					"BestPossibleHand": false
				}]
			}]
		}
	},
	"ErrorCode": 0,
	"ErrorMessage": ""
}
